/* eslint-disable global-require */
const axios = require('axios')

const NOTIFICATION_API = 'https://notification.manyconvert.com'

/**
 * Métricas Meta (enviadas, entregues, lidas, cliques) por template/status.
 * @param {string} uuid - UUID da loja
 * @param {string} start - YYYY-MM-DD
 * @param {string} end - YYYY-MM-DD
 */
export async function fetchTemplateAnalytics(uuid, start, end) {
  const { data } = await axios.get(
    `${NOTIFICATION_API}/api/cloud/templates/${encodeURIComponent(uuid)}/analytics`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
      },
      params: { start, end },
    },
  )
  return data
}

export default async function report(data_min, data_max, uuid) {
  const getReport = await axios.get(`${NOTIFICATION_API}/report`, {
    headers: {
      'Content-Type': 'application/json',
      accept: '*/*',
    },
    params: {
      uuid,
      data_min,
      data_max,
    },
  }).then(resp => resp.data)
  return getReport
}
